import { v4 as uuidv4 } from "uuid";
export class EntrySaveSearchModel {
    constructor() {
        this.id = uuidv4();
        this.entrySearch = null;
        this.isAdvanceSearch = false;
        this.searchName = "";
        this.isShared = false;
    }
}
export default class EntrySaveSearch extends EntrySaveSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
